
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to",
      function () {
        return require("private-next-pages/how-to.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to"])
      });
    }
  